import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../services/api";
import toast from "react-hot-toast";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSearch,
} from "react-icons/fa";
import { hasPermission } from "../../utils/permission";

function Permissions() {
  const [permissions, setPermissions] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPermissions();
  }, [page, search]);

  const loadPermissions = async () => {
    try {
      setLoading(true);

      const res = await API.get(
        `/permissions?page=${page}&search=${search}`
      );

      setPermissions(res.data.permissions || []);
      setPages(res.data.pages || 1);
    } catch (err) {
      console.log(err);
      toast.error("Failed to load permissions");
    } finally {
      setLoading(false);
    }
  };

  const deletePermission = async (id) => {
    if (
      !window.confirm(
        "Delete this permission?"
      )
    )
      return;

    try {
      await API.delete(
        `/permissions/${id}`
      );

      toast.success(
        "Permission deleted"
      );

      loadPermissions();
    } catch (err) {
      console.log(err);
      toast.error("Delete failed");
    }
  };

  return (
    <div>

      <div
        className="
        flex
        items-center
        justify-between
        mb-6
        flex-wrap
        gap-4
      "
      >
        <div>

          <h1
            className="
            text-4xl
            font-bold
          "
          >
            Permissions
          </h1>

          <p className="text-gray-400 mt-1">
            Manage system permissions
          </p>

        </div>

        {hasPermission("permission.add") && (
          <Link
            to="/admin/permissions/add"
            className="
          flex
          items-center
          gap-2
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
        "
          >
            <FaPlus />
            Add Permission
          </Link>
        )}

      </div>

      <div
        className="
        bg-[#111]
        rounded-2xl
        p-5
      "
      >

        <div
          className="
          relative
          mb-5
        "
        >
          <FaSearch
            className="
            absolute
            left-4
            top-4
            text-gray-500
          "
          />

          <input
            value={search}
            onChange={(e) => {
              setSearch(
                e.target.value
              );
              setPage(1);
            }}
            placeholder="Search Permission..."
            className="
            w-full
            bg-black
            border
            border-yellow-500/20
            rounded-xl
            pl-12
            p-3
          "
          />
        </div>

        <div className="overflow-auto">

          <table className="w-full">

            <thead>

              <tr
                className="
                border-b
                border-yellow-500/20
              "
              >
                <th className="text-left p-4">
                  #
                </th>

                <th className="text-left p-4">
                  Module
                </th>

                <th className="text-left p-4">
                  Permission Key
                </th>

                <th className="text-left p-4">
                  Permission Name
                </th>

                <th className="text-center p-4">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {loading ? (

                <tr>
                  <td
                    colSpan="5"
                    className="
                    text-center
                    py-10
                  "
                  >
                    Loading...
                  </td>
                </tr>

              ) : permissions.length === 0 ? (

                <tr>
                  <td
                    colSpan="5"
                    className="
                    text-center
                    py-10
                    text-gray-500
                  "
                  >
                    No Permissions Found
                  </td>
                </tr>

              ) : (

                permissions.map(
                  (
                    item,
                    index
                  ) => (

                    <tr
                      key={item.id}
                      className="
                      border-b
                      border-yellow-500/10
                      hover:bg-yellow-500/5
                    "
                    >

                      <td className="p-4">
                        {(page - 1) * 10 +
                          index +
                          1}
                      </td>

                      <td className="p-4">
                        {item.module_name}
                      </td>

                      <td className="p-4">
                        <span
                          className="
                          text-yellow-400
                          font-mono
                        "
                        >
                          {item.permission_key}
                        </span>
                      </td>

                      <td className="p-4">
                        {item.permission_name}
                      </td>

                      <td
                        className="
                        p-4
                        flex
                        justify-center
                        gap-3
                      "
                      >
                        {hasPermission("permission.edit") && (
                          <Link
                            to={`/admin/permissions/edit/${item.id}`}
                            className="
                          bg-blue-600
                          hover:bg-blue-700
                          w-10
                          h-10
                          rounded-lg
                          flex
                          items-center
                          justify-center
                        "
                          >
                            <FaEdit />
                          </Link>
                        )}

                        {hasPermission("permission.delete") && (
                          <button
                            onClick={() =>
                              deletePermission(
                                item.id
                              )
                            }
                            className="
                          bg-red-600
                          hover:bg-red-700
                          w-10
                          h-10
                          rounded-lg
                          flex
                          items-center
                          justify-center
                        "
                          >
                            <FaTrash />
                          </button>
                        )}

                      </td>

                    </tr>

                  )
                )

              )}

            </tbody>

          </table>

        </div>

        {pages > 1 && (

          <div
            className="
            flex
            justify-center
            gap-2
            mt-6
          "
          >

            {[...Array(pages)].map(
              (_, i) => (

                <button
                  key={i}
                  onClick={() =>
                    setPage(i + 1)
                  }
                  className={`
                    px-4
                    py-2
                    rounded-lg
                    ${page === i + 1
                      ? "bg-yellow-500 text-black"
                      : "bg-black border border-yellow-500/20"
                    }
                  `}
                >
                  {i + 1}
                </button>

              )
            )}

          </div>

        )}

      </div>

    </div>
  );
}

export default Permissions;